// extracted by mini-css-extract-plugin
export default {"detailContainer":"styles_detailContainer__FPCou","icon":"styles_icon__c-6Gt"};